import React, { useState } from 'react';
import { validateEmail } from '../../utils/helpers';
import { useForm, ValidationError } from '@formspree/react';

function ContactForm() {
    const [formState, setFormState] = useState({ name: '', email: '', message: '' });
    const [errorMessage, setErrorMessage] = useState('');
    const { name, email, message } = formState;
    const [state, handleSubmit] = useForm("mbjqgpbd");
    if (state.succeeded) {
        return <p>Thank you for contacting me!</p>;
    }

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     if (!errorMessage) {
    //         setFormState({
    //             [e.target.name]: e.target.value
    //         });
    //         console.log('Form', formState);
    //     }
    // };

    const handleChange = (e) => {
        if (e.target.name === 'email') {
            const isValid = validateEmail(e.target.value);
            if (!isValid) {
                setErrorMessage('Your email is invalid.');
            } else {
                setErrorMessage('');
            }
        } else {
            if (!e.target.value.length) {
                setErrorMessage(`${e.target.name} is required.`);
            } else {
                setErrorMessage('');
            }
        }
    };

    return (
        <section>
            <h3>Contact me</h3>
            <form id="contact-form" onSubmit={handleSubmit}>
                <div className='form-group'>
                    <label htmlFor="name">Name:</label>
                    <input className='form-control' type="text" name="name" defaultValue={name} onBlur={handleChange} />
                </div>
                <div className='form-group'>
                    <label htmlFor="email">Email address:</label>
                    <input className='form-control' type="email" name="email" defaultValue={email} onBlur={handleChange} />
                </div>
                <div className='form-group'>
                    <label htmlFor="message">Message:</label>
                    <textarea className='form-control' name="message" rows="5" defaultValue={message} onBlur={handleChange} />
                </div>
                {errorMessage && (
                    <div>
                        <p className="error-text">{errorMessage}</p>
                    </div>
                )}
                <button type="submit" disabled={state.submitting}>Submit</button>
            </form>
        </section>
    )
};

export default ContactForm;
